type WikiDiffLine = Readonly<{
  type: "added" | "removed" | "unchanged";
  text: string;
}>;
type DiffPlan = Readonly<{
  matches: number;
  step: (WikiDiffLine & Readonly<{ next: DiffPlan }>) | null;
}>;
function prependLine(
  type: WikiDiffLine["type"],
  text: string,
  next: DiffPlan,
): DiffPlan {
  return {
    matches: next.matches + (type === "unchanged" ? 1 : 0),
    step: { type, text, next },
  };
}
export function diffLines({
  oldLines,
  newLines,
}: Readonly<{
  oldLines: readonly string[];
  newLines: readonly string[];
}>): WikiDiffLine[] {
  const empty: DiffPlan = { matches: 0, step: null };
  let result = empty;
  let columns = newLines.toReversed().map((text) => {
    result = prependLine("added", text, result);
    return { text, plan: result };
  });
  let oldSuffix = empty;

  for (const oldText of oldLines.toReversed()) {
    let diagonal = oldSuffix;
    oldSuffix = prependLine("removed", oldText, oldSuffix);
    let right = oldSuffix;
    columns = columns.map(({ text, plan: below }) => {
      let plan: DiffPlan;

      if (oldText === text) plan = prependLine("unchanged", oldText, diagonal);
      else if (below.matches >= right.matches)
        plan = prependLine("removed", oldText, below);
      else plan = prependLine("added", text, right);

      diagonal = below;
      right = plan;
      return { text, plan };
    });
    result = right;
  }

  const rows: WikiDiffLine[] = [];
  let step = result.step;

  while (step) {
    rows.push({ type: step.type, text: step.text });
    step = step.next.step;
  }

  return rows;
}
